import { Avatar, Dropdown, Menu, MenuButton, MenuItem } from "@mui/joy";
import { clearProfile, setShowEditProfileModal } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../utils/authService";
import { useEffect, useState } from "react";
import { checkAuth } from "../../utils/authService";

function ProfileAvatar() {
  const dispatch = useDispatch();
  const username = useSelector((state) => state.user.profile.username);
  const firstName = useSelector((state) => state.user.profile.firstName);
  const lastName = useSelector((state) => state.user.profile.lastName);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifyAuth = async () => {
      const authStatus = await checkAuth();
      setIsAuthenticated(authStatus);
    };
    verifyAuth();
  }, []);

  const initials =
    firstName && lastName
      ? firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
      : null;
  return (
    <>
      <Dropdown>
        <MenuButton
          sx={{
            all: "unset",
            "&:hover": {
              all: "unset",
            },
          }}
        >
          {username && initials ? (
            <Avatar sx={{ cursor: "pointer" }}>{initials}</Avatar>
          ) : (
            <Avatar sx={{ cursor: "pointer" }} />
          )}
        </MenuButton>
        <Menu>
          {!isAuthenticated && (
            <MenuItem onClick={() => {
              const redirectUri = encodeURIComponent(window.location.href);
              window.location.href = `${process.env.REACT_APP_AUTH_URL}?redirectUri=${redirectUri}`;
            }}>
              Sign up / Log in
            </MenuItem>
          )}
          {isAuthenticated && (
            <>
              {username && (
                <MenuItem onClick={() => dispatch(setShowEditProfileModal(true))}>
                  Edit Profile
                </MenuItem>
              )}
              <MenuItem
                onClick={async () => {
                  await logout();
                  dispatch(clearProfile());
                  setIsAuthenticated(false);
                }}
              >
                Sign out
              </MenuItem>
            </>
          )}
        </Menu>
      </Dropdown>
    </>
  );
}

export default ProfileAvatar;
